import { useEffect } from 'react';

import { webSocketClient } from '@/shared/api/web-socket-client';
import { webSocketPublisher } from '@/shared/api/web-socket-publisher';
import { webSocketSubscriber } from '@/shared/api/web-socket-subscriber';

export function useWebSocketClient() {
    useEffect(() => {
        webSocketSubscriber.connect(webSocketClient);
        webSocketPublisher.connect(webSocketClient);
        webSocketClient.open();

        const abortController = new AbortController();
        document.addEventListener(
            'visibilitychange',
            () => {
                if (document.visibilityState === 'visible') {
                    webSocketClient.open();
                }
            },
            { signal: abortController.signal },
        );

        return () => {
            abortController.abort();
            webSocketSubscriber.disconnect();
            webSocketPublisher.disconnect();
            webSocketClient.close();
        };
    }, []);
}
